/**
 * The single home for the `Authorization: Bearer <token>` header.
 *
 * This lives in its own module — rather than in `apiClient` where it started —
 * because `apiClient` calls `axios.create()` and registers a response
 * interceptor at module scope. Any module importing the header helper from
 * there inherits those side effects, which broke every test that stubs axios
 * with a bare `jest.mock("axios")`. Keep this file dependency-free and
 * side-effect-free so it is safe to import from anywhere, including slices.
 */
export const bearerAuthHeaders = (token?: string | null): Record<string, string> => ({
  Authorization: `Bearer ${token ?? localStorage.getItem("accessToken2")}`,
});
